import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.998 15c-.374 0-.733-.147-1.003-.41L4.05 11.734c-1.906-1.846-2.552-4.54-1.646-6.858.052-.135.11-.267.171-.397A5.974 5.974 0 0 1 4.667 2a5.823 5.823 0 0 1 3.057-.994c.183-.008.369-.008.552 0A5.825 5.825 0 0 1 11.333 2a5.977 5.977 0 0 1 2.092 2.477c.062.13.118.263.17.397.907 2.319.26 5.011-1.646 6.858l-2.948 2.858c-.27.263-.63.41-1.003.409Zm.001-12.462a4.356 4.356 0 0 0-2.5.75c-.679.46-1.22 1.101-1.563 1.855-.047.1-.09.2-.13.301-.676 1.73-.172 3.763 1.284 5.175l2.907 2.82 2.907-2.82c1.457-1.412 1.96-3.443 1.284-5.176a4.531 4.531 0 0 0-.13-.3 4.47 4.47 0 0 0-1.562-1.854 4.356 4.356 0 0 0-2.498-.751h.001Z"
      fill="#9BA2B0"
    />
    <path
      d="M8 10c-.53 0-1.039-.265-1.414-.733C6.211 8.798 6.001 8.163 6 7.5c0-.663.211-1.298.586-1.767C6.961 5.264 7.47 5.001 8 5c.53 0 1.039.264 1.414.733S9.999 6.837 10 7.5c0 .663-.211 1.298-.586 1.767-.375.468-.884.732-1.414.733Zm0-3.568a.78.78 0 0 0-.604.313c-.16.2-.25.472-.25.755 0 .283.09.555.25.755.16.2.377.313.604.313a.78.78 0 0 0 .604-.313c.16-.2.25-.472.25-.755 0-.283-.09-.555-.25-.755A.78.78 0 0 0 8 6.432Z"
      fill="#9BA2B0"
    />
  </svg>
);

export default SvgComponent;
